import type { Components } from '@mui/material'

export const OmuiCountBadge: NonNullable<Components['OmuiCountBadge']> = {
  styleOverrides: {
    root: ({ theme }) => ({
      borderRadius: theme.shape['futureTheme.radius-sm'],
      display: 'inline-flex',
      alignItems: 'center',
      justifyContent: 'center',
      padding: theme.spacing(0, 1),
      minWidth: `calc(${theme.spacing(2)} + 6px)`, // 6px for content
      fontVariantNumeric: 'tabular-nums',
      textAlign: 'center',
      backgroundColor: theme.palette.futureTheme.bg.neutral.strong,
      // Need this to override specificity from MUI Chip
      '&&&': {
        ...theme.typography['futureTheme.extraSmall-semiBold'],
        color: theme.palette.futureTheme.text.inverted,
      },
    }),
  },
  variants: [
    {
      props: { color: 'secondary' },
      style: ({ theme }) => ({
        backgroundColor: theme.palette.futureTheme.bg.brand.default,
        '&&&': {
          color: theme.palette.futureTheme.text.brand.onBrand,
        },
      }),
    },
    {
      props: { color: 'success' },
      style: ({ theme }) => ({
        backgroundColor: theme.palette.futureTheme.bg.success.default,
        '&&&': {
          color: theme.palette.futureTheme.text.success.onSuccess,
        },
      }),
    },
    {
      props: { color: 'error' },
      style: ({ theme }) => ({
        backgroundColor: theme.palette.futureTheme.bg.danger.default,
        '&&&': {
          color: theme.palette.futureTheme.text.danger.onDanger,
        },
      }),
    },
    {
      props: { color: 'warning' },
      style: ({ theme }) => ({
        backgroundColor: theme.palette.futureTheme.bg.warning.default,
        '&&&': {
          color: theme.palette.futureTheme.text.warning.onWarning,
        },
      }),
    },
    {
      props: { color: 'info' },
      style: ({ theme }) => ({
        backgroundColor: theme.palette.futureTheme.bg.info.default,
        '&&&': {
          color: theme.palette.futureTheme.text.info.onInfo,
        },
      }),
    },
    {
      props: { color: 'futureTheme.neutralStrong' },
      style: ({ theme }) => ({
        backgroundColor: theme.palette.futureTheme.bg.inverted,
        '&&&': {
          color: theme.palette.futureTheme.text.inverted,
        },
      }),
    },
    {
      props: { color: 'futureTheme.bronze' },
      style: ({ theme }) => ({
        backgroundColor: theme.palette.futureTheme.bg.utility.bronze.default,
        '&&&': {
          color: theme.palette.futureTheme.text.utility.bronze['on-bronze'],
        },
      }),
    },
    {
      props: { color: 'futureTheme.gold' },
      style: ({ theme }) => ({
        backgroundColor: theme.palette.futureTheme.bg.utility.gold.default,
        '&&&': {
          color: theme.palette.futureTheme.text.utility.gold['on-gold'],
        },
      }),
    },
    {
      props: { color: 'futureTheme.orange' },
      style: ({ theme }) => ({
        backgroundColor: theme.palette.futureTheme.bg.utility.orange.default,
        '&&&': {
          color: theme.palette.futureTheme.text.utility.orange['on-orange'],
        },
      }),
    },
    {
      props: { color: 'futureTheme.lime' },
      style: ({ theme }) => ({
        backgroundColor: theme.palette.futureTheme.bg.utility.lime.default,
        '&&&': {
          color: theme.palette.futureTheme.text.utility.lime['on-lime'],
        },
      }),
    },
    {
      props: { color: 'futureTheme.mint' },
      style: ({ theme }) => ({
        backgroundColor: theme.palette.futureTheme.bg.utility.mint.default,
        '&&&': {
          color: theme.palette.futureTheme.text.utility.mint['on-mint'],
        },
      }),
    },
    {
      props: { color: 'futureTheme.pink' },
      style: ({ theme }) => ({
        backgroundColor: theme.palette.futureTheme.bg.utility.pink.default,
        '&&&': {
          color: theme.palette.futureTheme.text.utility.pink['on-pink'],
        },
      }),
    },
  ],
}
